<template>
    <employees-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <employee-cash-operation-edit-form :disabled="_.itemDisabled" v-model="_.item" :employee="_parent.item" />
        </sub-item-show-view>
    </employees-show-page>
</template>

<script>
    import EmployeesShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import EmployeeCashOperationEditForm from './Shared/EmployeeCashOperationEditForm'

    export default {
        name: 'EmployeesShowCashOperationsEditPage',
        inheritAttrs: false,
        components: {
            EmployeesShowPage,
            SubItemShowView,
            EmployeeCashOperationEditForm,
        },
    }
</script>

<style scoped>

</style>